import React from 'react'
import WorkListViewStoreProviderMn, {
  useWorkListViewMnStore
} from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { Grid, IconButton, makeStyles } from '@material-ui/core'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { useRoutes } from 'hooks'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UI'
import { CheckCircleIcon, MinusCircleIcon } from 'asterX-UI/Icons'
import Header from 'components/Mobile/WorkListView/Header'
import StatusProgress from 'components/Mobile/WorkListView/StatusProgress'
import ClientView from 'components/Mobile/WorkListView/ClientView'
import { a11yProps, Tab, Tabs } from 'asterX-UI/Tabs'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import TaskTab from 'pages/Mobile/WorkListView/Manager/Tabs/Tasks/TaskTab'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import CommentsTab from 'components/Mobile/WorkListView/CommentsTab'
import CallsTab from 'pages/Mobile/WorkListView/Manager/Tabs/Calls/CallsTab'
import WlAssessmentsTab from 'pages/Mobile/WorkListView/Manager/Tabs/WlAssessments/WlAssessmentsTab'
import CreditRequestsTab from 'pages/Mobile/WorkListView/Manager/Tabs/CreditRequests/CreditRequestsTab'
import PaymentsTab from 'pages/Mobile/WorkListView/Manager/Tabs/Payments/PaymentsTab'
import { Modal } from 'asterX-UI/Modals'
import ClientNeeds from 'components/Mobile/ClientNeeds'
import { parseJson } from 'lib/utils'
import HistoryOfSelection from 'components/Mobile/HistoryOfSelection'

const WorkListViewManagerMobile = props => (
  <WorkListViewStoreProviderMn {...props}>
    <WorkListView />
  </WorkListViewStoreProviderMn>
)

export default WorkListViewManagerMobile

export const WorkListViewManagerMobileModal = ({ open, onClose, ...props }) => (
  <WorkListViewStoreProviderMn {...props}>
    <Modal open={open} onClose={onClose} fullScreen>
      <WorkListView isModal onClose={onClose} />
    </Modal>
  </WorkListViewStoreProviderMn>
)

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 4
  },
  checkRop: {
    display: 'flex',
    gap: 6
  },
  text: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: 'Inter'
  }
}))

const TabLabel = ({ count, isActive, label }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        gap: 8,
        display: 'flex'
      }}
    >
      {' '}
      {label}
      {count > 0 && (
        <ChipStandard
          {...(isActive
            ? {
                color: PRIMARY_COLORS[700],
                backgroundColor: PRIMARY_COLORS[100]
              }
            : {
                color: GRAY_COLORS[700],
                backgroundColor: GRAY_COLORS[100]
              })}
        >
          {count}
        </ChipStandard>
      )}
    </div>
  )
}

const WorkListView = ({ isModal, onClose = () => {} }) => {
  const tabsList = [
    {
      label: 'Все',
      value: 'COMMENTS'
    },
    {
      label: 'Результаты задачи',
      value: '@result'
    },
    {
      label: 'Причина упущенных',
      value: 'MISSING'
    },
    {
      label: 'Фин сервис',
      value: 'FINSERVICE'
    }
  ]

  const { goPrevPage } = useRoutes()
  const classes = useStyles()
  const { workListViewStore, workListViewStoreFunc } = useWorkListViewMnStore()
  const { sale, comments } = workListViewStore

  const configTabs = () => {
    return [
      {
        label: (
          <TabLabel
            label={'Задачи'}
            count={workListViewStore.taskList?.length}
            isActive={workListViewStore.selectedTab === 0}
          />
        ),
        value: 0
      },
      { label: 'Комментарии', value: 1 },
      { label: 'Кредитные заявки', value: 2 },
      { label: 'Звонки', value: 3 },
      { label: 'РЛ оценки', value: 4 },
      { label: '1С и оплата', value: 5 },
      { label: 'Потребности клиента', value: 6 },
      { label: 'История подбора', value: 7 }
    ]
  }

  const tabsContent = [
    <TaskTab />,
    <CommentsTab
      comments={comments}
      tabsList={tabsList}
      onAddComment={workListViewStoreFunc.addComments}
    />,
    <CreditRequestsTab />,
    <CallsTab />,
    <WlAssessmentsTab />,
    <PaymentsTab />,
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        gap: 5,
        padding: 10
      }}
    >
      <ClientNeeds isDisabled commentsRSE={parseJson(sale.commentsRSE)} />
    </div>,
    <HistoryOfSelection id={sale?.id} tradeInCarVin={sale?.tradeInCarVin} />
  ]
  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: '#667085'
            }}
            onClick={isModal ? onClose : goPrevPage}
            size={'small'}
          >
            <ChevronLeftIcon />
          </IconButton>

          <div className={classes.checkRop}>
            {sale?.ropCheck ? (
              <>
                <CheckCircleIcon
                  style={{
                    color: SUCCESS_COLORS[600],
                    fontSize: 18
                  }}
                />
                <div className={classes.text}>{'Проверено РОП-ом'}</div>
              </>
            ) : (
              <>
                <MinusCircleIcon
                  style={{
                    color: ERROR_COLORS[600],
                    fontSize: 18
                  }}
                />
                <div className={classes.text}>{'РОП не проверил'}</div>
              </>
            )}
          </div>
        </div>
      }
    >
      <LoaderBackdrop
        loading={workListViewStore.initLoading || workListViewStore.loading}
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Header
            wlId={sale?.id}
            status={sale?.saleStatus}
            carfinStatus={sale?.carfinStatus}
            globalId={sale?.globalId}
          />
        </Grid>

        {sale?.contractStatusTrack?.name && (
          <Grid item xs={12}>
            <StatusProgress contractStatusTrack={sale?.contractStatusTrack} />
          </Grid>
        )}

        <Grid item xs={12}>
          <ClientView sale={sale} />
        </Grid>

        <Grid item xs={12}>
          <Tabs
            value={workListViewStore.selectedTab}
            onChange={workListViewStoreFunc.onChangeTab}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="primary"
            textColor="primary"
          >
            {configTabs().map((tab, index) => (
              <Tab
                label={tab.label}
                {...a11yProps(tab.value)}
                value={tab.value}
                key={`tab_${index}`}
              />
            ))}
          </Tabs>
        </Grid>
        {tabsContent[workListViewStore.selectedTab]}
      </Grid>
    </PageContainerMobile>
  )
}
